/* New Comfort — koopblok 2026 (snippets/nc-buybox.liquid)
   - calculator SprayPay (maanden kiezen) en uitklappen van de betaalopties
   - verwachte bezorgdatum bij koerierlevering (werkdagen)
   - B2B-garantiejaren en de installatie-optie gaan mee in de winkelwagen
   - sticky balk op mobiel
   Event delegation: Dawn vervangt #price-… bij een andere variant. */
(() => {
  if (window.ncBuybox) return;
  window.ncBuybox = true;

  const eur = (cents, decimals) =>
    '€' + (cents / 100).toLocaleString('nl-NL', {
      minimumFractionDigits: decimals ? 2 : 0,
      maximumFractionDigits: decimals ? 2 : 0,
    });

  /* --- betaalopties uitklappen ----------------------------------- */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-ncbb-toggle]');
    if (!t) return;
    const panel = document.getElementById(t.getAttribute('aria-controls'));
    if (!panel) return;
    const open = panel.hidden;
    panel.hidden = !open;
    t.setAttribute('aria-expanded', String(open));
    t.textContent = open ? t.dataset.close : t.dataset.open;
  });

  /* --- SprayPay-calculator --------------------------------------- */
  document.addEventListener('input', (e) => {
    const range = e.target.closest('[data-ncbb-range]');
    if (!range) return;
    const calc = range.closest('[data-ncbb-calc]');
    const months = Number(range.value);
    const price = Number(calc.dataset.price);
    const fee = Number(calc.dataset.fee);
    const total = price + Math.round((price * fee) / 100);
    calc.querySelector('[data-ncbb-n]').textContent = `${months} maanden`;
    calc.querySelector('[data-ncbb-m]').textContent = eur(Math.round(total / months), true);
    calc.querySelectorAll('[data-ncbb-tick]').forEach((s) =>
      s.classList.toggle('is-on', Number(s.dataset.ncbbTick) === months)
    );
  });

  /* --- bezorgdatum: verzonden op de volgende werkdag + min..max werkdagen */
  const addWorkdays = (date, n) => {
    const d = new Date(date);
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      const day = d.getDay();
      if (day !== 0 && day !== 6) n--;
    }
    return d;
  };
  const fmt = (d) => d.toLocaleDateString('nl-NL', { weekday: 'short', day: 'numeric', month: 'short' });
  const fillEta = () =>
    document.querySelectorAll('[data-ncbb-eta]').forEach((el) => {
      const ship = addWorkdays(new Date(), 1);
      el.textContent = `${fmt(addWorkdays(ship, Number(el.dataset.min)))} – ${fmt(addWorkdays(ship, Number(el.dataset.max)))}`;
    });

  /* --- B2B-garantie: labels, medaillon en totaal ----------------- */
  const b2bTotal = (root) => {
    const war = root.querySelector('[data-ncbb-war]');
    const out = root.querySelector('[data-ncbb-b2b-total]');
    if (!war || !out) return;
    const extra = Number(war.querySelector('input:checked')?.value || 0);
    out.textContent = `totaal ${eur(Number(war.dataset.base) + extra * Number(war.dataset.excl))} excl. btw`;
  };

  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-ncbb-war] input');
    if (!input) return;
    const root = input.closest('.product__info-container') || document;
    const years = Number(input.value) + 1;
    root.querySelector('[data-ncbb-war-label]').textContent = `${years} jaar`;
    root.querySelectorAll('[data-ncbb-war-seal]').forEach((s) => (s.textContent = years));
    b2bTotal(root);
  });

  /* --- extra's mee in de winkelwagen ----------------------------- */
  const extras = (root) => {
    const items = [];
    const addon = root.querySelector('[data-ncbb-addon] input:checked');
    if (addon) {
      const el = addon.closest('[data-ncbb-addon]');
      items.push({ id: Number(el.dataset.variant), quantity: 1, properties: { Bij: el.dataset.for } });
    }
    const war = root.querySelector('[data-ncbb-war]');
    const extra = Number(war?.querySelector('input:checked')?.value || 0);
    if (war && extra > 0) {
      items.push({ id: Number(war.dataset.variant), quantity: extra, properties: { Bij: war.dataset.for } });
    }
    return items;
  };

  document.addEventListener(
    'submit',
    async (e) => {
      const form = e.target;
      const productForm = form.closest && form.closest('product-form');
      const root = productForm && productForm.closest('.product__info-container');
      if (!root || !root.querySelector('.nc-bb-pre')) return;
      if (form.dataset.ncbbPass === '1') {
        delete form.dataset.ncbbPass;
        return;
      }
      const items = extras(root);
      if (!items.length) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      try {
        await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
      } catch (err) {
        /* de stoel zelf gaat hoe dan ook in de winkelwagen */
      }
      form.dataset.ncbbPass = '1';
      form.requestSubmit();
    },
    true
  );

  /* --- sticky balk (mobiel) -------------------------------------- */
  const initBar = () => {
    const bar = document.querySelector('[data-ncbb-mbar]');
    if (!bar) return;
    const submit = document.getElementById(`ProductSubmitButton-${bar.dataset.section}`);
    if (!submit) return;
    new IntersectionObserver(([entry]) => {
      const on = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', String(!on));
      bar.querySelector('[data-ncbb-mbar-btn]').tabIndex = on ? 0 : -1;
    }).observe(submit);
    bar.querySelector('[data-ncbb-mbar-btn]').addEventListener('click', () => {
      if (bar.dataset.href) window.location.href = bar.dataset.href;
      else submit.closest('form')?.requestSubmit();
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        const v = data && data.variant;
        if (!v) return;
        const cents = bar.dataset.seg === 'b2b' ? Math.round(v.price / 1.21) : v.price;
        bar.querySelector('[data-ncbb-mbar-price]').textContent = eur(cents);
        const img = bar.querySelector('img');
        if (img && v.featured_image?.src) img.src = `${v.featured_image.src}${v.featured_image.src.includes('?') ? '&' : '?'}width=120`;
      });
    }
  };

  const init = () => {
    fillEta();
    initBar();
    document.querySelectorAll('.product__info-container').forEach(b2bTotal);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
